import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const CallToAction = () => (
  <section className="on-dark bg-brand px-6 py-12 text-center sm:px-10 md:py-14 lg:px-12 lg:py-16">
    <div className="shell">
      <h2 className="font-display text-vt-h2 font-extrabold leading-[1.12] tracking-[-0.03em] text-white">
        Parlons de vos données.
      </h2>
      <p className="mx-auto mt-6 max-w-[640px] text-vt-chapo font-medium leading-relaxed text-white/80">
        Un premier échange sans frais pour cadrer le besoin, estimer l'effort et
        vérifier que nous sommes les bonnes personnes.
      </p>

      <div className="mt-8 flex flex-wrap justify-center gap-4">
        <Link to="/#contact" className="btn-accent">
          Consultation gratuite
          <ArrowRight className="h-5 w-5" strokeWidth={2.4} aria-hidden="true" />
        </Link>
        <a href="mailto:info@geodonnee.com" className="btn-ghost-w">
          info@geodonnee.com
        </a>
      </div>
    </div>
  </section>
);
